<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
      *ngFor="let bc of breadcrumbs; let last = last"
      [ngClass]="{ active: last }"
      [attr.aria-current]="last ? 'page' : null"
    >
      <ng-container *ngIf="!last">
        <a [routerLink]="bc.url">{{ bc.label }}</a>
      </ng-container>
      <ng-container *ngIf="last">
        {{ bc.label }}
      </ng-container>
    </li>
  </ol>
</nav>
